module.exports = __webpack_public_path__ + "static/img/test.7b7c3eb9.png";